export const pageSizes = [20, 50, 100, 500, 1000];
export const defaultPageSize = 20;

type SortValue = string | number | boolean | null | undefined;

export function compareValues(a: SortValue, b: SortValue): number {
  const emptyA = a === null || a === undefined || a === '';
  const emptyB = b === null || b === undefined || b === '';
  if (emptyA || emptyB) return emptyA === emptyB ? 0 : emptyA ? 1 : -1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  if (typeof a === 'boolean' && typeof b === 'boolean') return Number(a) - Number(b);
  return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
}

export function sortRows<T>(
  rows: readonly T[],
  value: (row: T) => SortValue,
  direction: 'asc' | 'desc',
): T[] {
  const sign = direction === 'asc' ? 1 : -1;
  return rows
    .map((row, index) => ({ row, index, key: value(row) }))
    .sort((x, y) => {
      const emptyX = x.key === null || x.key === undefined || x.key === '';
      const emptyY = y.key === null || y.key === undefined || y.key === '';
      if (emptyX !== emptyY) return emptyX ? 1 : -1;
      return compareValues(x.key, y.key) * sign || x.index - y.index;
    })
    .map((x) => x.row);
}
